/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Itemnotfound_Searchinvite3Inputs */

const he_itemnotfound_searchinvite3 = /** @type {(inputs: Itemnotfound_Searchinvite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בינתיים, מה דעתכם לגלות מבצעים ומוצרים מעניינים אחרים?`)
};

const en_itemnotfound_searchinvite3 = /** @type {(inputs: Itemnotfound_Searchinvite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the meantime, how about discovering other deals and interesting products?`)
};

/**
* | output |
* | --- |
* | "In the meantime, how about discovering other deals and interesting products?" |
*
* @param {Itemnotfound_Searchinvite3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const itemnotfound_searchinvite3 = /** @type {((inputs?: Itemnotfound_Searchinvite3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Itemnotfound_Searchinvite3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_itemnotfound_searchinvite3(inputs)
	return en_itemnotfound_searchinvite3(inputs)
});
export { itemnotfound_searchinvite3 as "itemNotFound_searchInvite" }